import { render } from "./FormularioBrinde.vue?vue&type=template&id=4aeed42e&scoped=true"
import script from "./FormularioBrinde.vue?vue&type=script&lang=js"
export * from "./FormularioBrinde.vue?vue&type=script&lang=js"

import "./FormularioBrinde.vue?vue&type=style&index=0&id=4aeed42e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aeed42e"]])

export default __exports__